export default function ({ store, redirect }) {
  if (store.state.auth.user && (!store.state.auth.user.portal_configuration ||
      !store.state.auth.user.site_users.length)) {
    return redirect('/errors/noaccess');
  }
}
